<div class="trial-start-guide-wrapper">
  <div class="animate-fade-in sm-relative sm-rounded-t sm-bg-default-blue sm-px-4 sm-py-6 sm-text-white">
    <h4 data-test="welcome-title" class="sm-text-xl sm-font-medium">{{ welcomeToDashpivot }}</h4>
    <p data-test="welcome-text" class="sm-text-sm sm-font-normal">
      {{ thanksForSigningUp }}
    </p>
    <img
      data-test="welcome-stars"
      class="sm-absolute sm-top-4 sm-right-4"
      src="assets/images/trial-start-guide/stars.svg"
      alt="Two dark blue stars in the background"
    />
  </div>
  <div data-test="trial-guide" class="w-100 sm-p-4">
    <cc-trial-start-guide-accordion
      class="trial-guide-accordion"
      [accordionPanels]="trialStartGuidePopulated"
    ></cc-trial-start-guide-accordion>
    <span class="mt-3 guide-expiry d-block text-muted sm-text-xs" i18n>{{ guideExpiry }}</span>
  </div>
</div>
